(() => {
  'use strict';
  const header = document.querySelector('.sf-header .header__wrapper');
  if (!header || !document.body.classList.contains('pinball-v15-store')) return;
  const update = () => document.body.style.setProperty('--pinball-store-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
  update();
  if (typeof ResizeObserver === 'function') new ResizeObserver(update).observe(header);
  window.addEventListener('resize', update, { passive: true });
  document.fonts?.ready.then(update);
})();


(() => {
  'use strict';
  const cta = document.querySelector('.fx-gameplay-landing .gl-hero .fx-purchase-primary');
  if (!cta || !document.body.classList.contains('pinball-v15-store') || !('IntersectionObserver' in window)) return;
  const update = visible => document.body.classList.toggle('pfx-hero-order-visible', visible);
  const bounds = cta.getBoundingClientRect();
  update(bounds.bottom > -24 && bounds.top < window.innerHeight + 24);
  const observer = new IntersectionObserver(entries => {
    update(entries[0].isIntersecting);
  }, { rootMargin: '24px 0px', threshold: 0 });
  observer.observe(cta);
})();
